export const pro_month = "pro-month";
export const pro_year = "pro";
export const premium_month = "premium-month";
export const premium_year = "premium";
